import {FC} from 'react';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';

import {IContentTreeItem} from '../../../../shared/types/workContent.types';
import {WorkDataItem} from './WorkDataItem';
import {Stack, Typography} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

interface IWorkData {
  template: IContentTreeItem[];
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('UTC');

export const WorkData: FC<IWorkData> = ({template}) => {
  return (
    <LocalizationProvider
      localeText={{
        clearButtonLabel: 'Сбросить',
        okButtonLabel: 'Подтвердить',
        dateTimePickerToolbarTitle: 'Выбрать дату и время',
        datePickerToolbarTitle: 'Выбрать дату',
      }}
      dateAdapter={AdapterDayjs}
      adapterLocale={'ru'}
    >
      <Stack>
        <Stack direction="row" justifyContent="center" alignItems="center" sx={{mb: 3, position: 'relative'}}>
          <Typography variant="h5">Рабочие данные</Typography>
        </Stack>
        {template.map((item) => (
          <WorkDataItem key={item.name} item={item} />
        ))}
      </Stack>
    </LocalizationProvider>
  );
};
